/**
 * App configuration event name
 */
export enum AppConfigurationEventName {
  OnConfigurationUpdate = 'OnConfigurationUpdate',
}
